import axios from "axios";
import { sweetAlertError, sweetAlertSuccess } from "@/plugins/swal.js";
import { BACKEND_URL } from "@/plugins/consts.js";

const instance = axios.create({
    baseURL: BACKEND_URL + '/dashboard',
    timeout: 15000,
});

// Add request interceptor to include timezone
instance.interceptors.request.use(config => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['x-timezone'] = timezone; // Or 'timezone' if you prefer
    return config;
}, error => {
    return Promise.reject(error);
});

const handleSuccessResponse = response => {
    if (response.data.message) {
        sweetAlertSuccess(response.data.message);
    }

    return response.data.data;
};

const handleErrorResponse = error => {
    if (error.response?.data?.message) {
        sweetAlertError(error.response.data.message);
    }

    return Promise.reject(error.response?.data?.errors || error);
};

instance.interceptors.response.use(handleSuccessResponse, handleErrorResponse);

window.axios = instance;
